import { Image } from 'react-bootstrap'
import ImageNoData from '../../images/icon-no-data.svg'

export default function ImageNoDataCustom() {
  return (
    <div className="p-5">
      <Image src={ImageNoData} style={{ width: 100 }} fluid />
      <div className="mt-2" style={{ color: '#7f7f7f' }}>
        - No Data -
      </div>
    </div>
  )
}
